import UserService from './user-services';
import FileService from './file-service';

const userService = new UserService('');
const fileService = new FileService('');

export { userService, fileService };
